// Global scripts, available on every page

// Accordion - school-days-faq.liquid

if (document.querySelector('.accordion')) {
  const items = document.querySelectorAll('.accordion button');

  function toggleAccordion() {
    const itemToggle = this.getAttribute('aria-expanded');

    //     for (i = 0; i < items.length; i++) {
    //       items[i].setAttribute('aria-expanded', 'false');
    //     }

    if (itemToggle == 'false') {
      this.setAttribute('aria-expanded', 'true');
    } else {
      this.setAttribute('aria-expanded', 'false');
    }
  }

  items.forEach((item) => item.addEventListener('click', toggleAccordion));
}

// Anchor link smooth scroll - fabrics-show-case.liquid

document.addEventListener('click', (event) => {
  if (event.defaultPrevented) return;
  if (!(event.target instanceof Element)) return;

  const anchor = event.target.closest('a[href*="#"]');
  if (!anchor || anchor.matches('[allow-hash-change]')) return;

  if (anchor.pathname !== window.location.pathname || anchor.search !== window.location.search) return;

  const url = new URL(anchor.href, window.location.origin);
  if (!url.hash) return;

  const target = document.querySelector(url.hash);
  if (!target) return;

  event.preventDefault();
  target.scrollIntoView({
    behavior: window.matchMedia('(prefers-reduced-motion: no-preference)').matches ? 'smooth' : 'auto',
    block: 'start'
  });

  document.documentElement.dispatchEvent(new CustomEvent('hashchange:simulate', {
    bubbles: true,
    detail: { hash: url.hash }
  }));
});

// Back to Top Button - related-products.liquid / product-recommendations
// Use delegated handling so it also works when recommendations render asynchronously.
document.addEventListener('click', (event) => {
  if (!(event.target instanceof Element)) return;

  const backToTopBtn = event.target.closest('.back-to-top-button .button');
  if (!backToTopBtn) return;

  window.scrollTo({
    top: 0,
    behavior: window.matchMedia('(prefers-reduced-motion: no-preference)').matches ? 'smooth' : 'auto'
  });
});

// FAQ toggle - ambassadors-faq.liquid

if (document.querySelector('.faq li .question')) {
  $('.faq li .question').click(function () {
    $(this).find('.plus-minus-toggle').toggleClass('collapsed');
    $(this).parent().toggleClass('active');
  });
}

// Extended hours toggle - page-store.liquid

if (document.querySelector('.extended-hours-heading')) {
  $(document).ready(function () {
    $('.extended-hours-heading').on('click', function () {
      $(this).toggleClass('active');
      $(this).next('.extended-hours-text').slideToggle();
    });
  });
}

// Read more - description.liquid

if (document.getElementById('readMoreBtn')) {
  window.readMore = function () {
    var dots = document.getElementById('dots');
    var moreText = document.getElementById('more');
    var btnText = document.getElementById('readMoreBtn');

    if (dots.style.display === 'none') {
      dots.style.display = 'inline';
      btnText.innerHTML = 'Read more';
      moreText.style.display = 'none';
    } else {
      dots.style.display = 'none';
      btnText.innerHTML = 'Read less';
      moreText.style.display = 'inline';
    }
  };
}
